import { secret } from '@iwentsourcing/core/realm/secret.js';
import { createGoogleOAuth } from '@iwentsourcing/core/authentication/providers/google.js';
import { createMicrosoftOAuth } from '@iwentsourcing/core/authentication/providers/microsoft.js';
import { defineRealm } from '@iwentsourcing/core/realm/define-realm.js';

export const todoRealm = defineRealm('todo', {
  providers: {
    microsoft: createMicrosoftOAuth({
      clientId: 'b7cd7686-6e5c-4224-a1d3-b974f00635c7',
      clientSecret: secret('MICROSOFT_CLIENT_SECRET'),
      tenant: 'common',
    }),
    google: createGoogleOAuth({
      clientId:
        '520005346035-rbe6toslf223ks3cocktgfvqaurcg4dq.apps.googleusercontent.com',
      clientSecret: secret('GOOGLE_CLIENT_SECRET'),
    }),
  },
});
